export default "__VITE_ASSET__Cxx7vPvn__"